import { useState, useContext, useMemo } from 'react';
import { FolderOutlined, FolderOpenOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { MaterialManageContext } from '../hooks/MaterialManageContext';
import styles from './index.module.scss';

// 菜单数据（后续从接口获取）
const MENU_DATA = [
    {
        key: 'refImage',
        label: '参考图管理',
        count: 124,
        children: [
            { key: 'refImage_all', label: '全部参考图', count: 124 },
            { key: 'refImage_tryon', label: '试衣参考图', count: 124 },
            { key: 'refImage_pose', label: '姿势裂变参考图', count: 124 },
            { key: 'refImage_shoes', label: '鞋子上脚参考图', count: 124 },
            { key: 'refImage_glasses', label: '眼镜试戴参考图', count: 124 },
            { key: 'refImage_bg', label: '背景参考图', count: 124 },
        ]
    },
    {
        key: 'outdoor',
        label: '户外参考图',
        count: 124,
        children: [],
    },
    {
        key: 'album2025',
        label: '2025图片整理',
        count: 124,
        children: [],
    },
];

// 底部固定菜单
const BOTTOM_MENU = [
    { key: 'templateManage', label: '模特图管理', tag: '敬请期待' },
    { key: 'referManage', label: '参考图管理', tag: '敬请期待' },
];

const Sidebar = () => {
    const { activeMenu, setActiveMenu, setActiveMenuName } = useContext(MaterialManageContext);
    const [expandedKeys, setExpandedKeys] = useState(['refImage']); // 默认展开参考图管理

    // 默认选中全部参考图
    useState(() => {
        if (!activeMenu) {
            setActiveMenu('refImage_all');
            setActiveMenuName('全部参考图');
        }
    });

    const toggleExpand = (key) => {
        setExpandedKeys(prev =>
            prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
        );
    };

    const handleMenuClick = (key, label) => {
        setActiveMenu(key);
        setActiveMenuName(label);
    };

    return (
        <div className={styles.Sidebar}>
            {/* 顶部 Tab 切换 */}
            <div className={styles.tabHeader}>
                <span className={styles.tabActive}>个人素材</span>
                <span className={styles.tab}>企业素材</span>
            </div>

            {/* 菜单列表 */}
            <div className={`${styles.menuList} _beauty_scrollbar`}>
                {MENU_DATA.map(group => (
                    <div key={group.key} className={styles.menuGroup}>
                        {/* 一级菜单 */}
                        <div
                            className={`${styles.menuItem} ${styles.menuGroupTitle} ${activeMenu === group.key ? styles.active : ''}`}
                            onClick={() => {
                                toggleExpand(group.key);
                                if (!group.children?.length) {
                                    handleMenuClick(group.key, group.label);
                                }
                            }}
                        >
                            <span className={styles.menuIcon}>
                                {expandedKeys.includes(group.key) ? <FolderOpenOutlined /> : <FolderOutlined />}
                            </span>
                            <span className={styles.menuLabel}>{group.label}</span>
                            <span className={styles.menuCount}>{group.count}</span>
                        </div>

                        {/* 二级菜单 */}
                        {expandedKeys.includes(group.key) && group.children?.map(child => (
                            <div
                                key={child.key}
                                className={`${styles.menuItem} ${styles.menuChild} ${activeMenu === child.key ? styles.active : ''}`}
                                onClick={() => handleMenuClick(child.key, child.label)}
                            >
                                <span className={styles.menuIcon}><FolderOutlined /></span>
                                <span className={styles.menuLabel}>{child.label}</span>
                                <span className={styles.menuCount}>{child.count}</span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>

            {/* 底部固定菜单 */}
            <div className={styles.bottomMenu}>
                {BOTTOM_MENU.map(item => (
                    <div key={item.key} className={`${styles.menuItem} ${styles.bottomMenuItem}`}>
                        <span className={styles.menuIcon}><FolderOutlined /></span>
                        <span className={styles.menuLabel}>{item.label}</span>
                        {item.tag && <span className={styles.menuTag}>{item.tag}</span>}
                    </div>
                ))}
            </div>

            {/* 新建文件夹按钮 */}
            <div className={styles.createFolderBtn}>
                <Button type="primary" icon={<PlusOutlined />} block>
                    新建文件夹
                </Button>
            </div>
        </div>
    );
};

export default Sidebar;